import React from "react";

const Video = () => {
  return (
    <section className="section-wrapper">
      <div className="video-wrapper">
        <iframe
          src="https://player.vimeo.com/video/670401780?h=d7cbcbba12&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          title="Aquaheat Plumbing &amp;amp; Heating"
        ></iframe>
      </div>
    </section>
  );
};

export default Video;
